
import Qs from 'qs'

export function goWxLogin (_this) {
  let queryStr = ''
  if (sessionStorage.getItem('flag')) {
    queryStr += '?flag=' + sessionStorage.getItem('flag')
  }
  if (JSON.stringify(_this.$route.query) !== '{}') {
    if (queryStr.length > 0) {
      queryStr += '&' + Qs.stringify(_this.$route.query)
    } else {
      queryStr += '?' + Qs.stringify(_this.$route.query)
    }
  }
  let returnUrl = _this.$route.path + queryStr
  window.location.href = process.env.WX_LOGIN_URL + '?returnUrl=' + returnUrl
}

export function isWxBrowser () {
  var u = navigator.userAgent
  console.log(u)
  return u.indexOf('MicroMessenger') > -1 
}

// 判断是否企业微信
export function isWxWork () {
  var u = navigator.userAgent
  console.log(u)
  return u.indexOf('wxwork') > -1
}


export function gotoLogin (_this) {
  console.log(isWxBrowser())
  if (isWxBrowser() && !isWxWork()) {
    goWxLogin(_this)
  } else {
    // let _this = this
    _this.$dialog.alert({
      message: '请先登录!'
    }).then(() => {
      _this.$router.push({ name: 'login' })
    }).catch(() => {})
  }
}

export function gotoConfirmLogin (_this) {
  console.log(isWxBrowser())
  if (isWxBrowser()) {
    goWxLogin(_this)
  } else {
    // let _this = this
    _this.$dialog.confirm({
      message: '请先登录!'
    }).then(() => {
      _this.$router.push({ name: 'login' })
    }).catch(() => {})
  }
}

export function gotoBindMobile (_this) {
  _this.$dialog.confirm({
    message: '请先绑定手机号!'
  }).then(() => {
    _this.$router.push({ name: 'BindMobile' })
  }).catch(() => {})
}



// WEBPACK FOOTER //
// ./src/utils/login.js